module.exports = __webpack_public_path__ + "img/frame-5.e306d06d.png";